/*
 *   Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *   This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *   No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accEsignatureArtifactDownload', ['fileDownload', (fileDownload) => ({
            replace: true,
            transclude: true,
            template: '<a href ng-click="download()" ng-transclude></a>',
            scope: {
                url: '<'
            },
            controller: ['$scope', ($scope) => {
                $scope.download = () => fileDownload($scope.url)
            }]
        })]
    );
